// extracted by mini-css-extract-plugin
export default {"googleCalendarCard":"GoogleCalendarSourceCard_googleCalendarCard__cHFBm"};